const CREDIT = 1_000_000;

export function formatCredits(micros: number): string {
  const credits = micros / CREDIT;
  if (credits >= 10_000) {
    return credits.toLocaleString('en-US', { notation: 'compact', maximumFractionDigits: 1 });
  }
  return credits.toLocaleString('en-US', {
    maximumFractionDigits: credits >= 100 ? 0 : 2,
  });
}

export function creditsToMicros(credits: number): number {
  return Math.round(credits * CREDIT);
}

export function microsToCredits(micros: number): number {
  return micros / CREDIT;
}

export function formatDuration(ms: number): string {
  if (ms < 1_000) return `${ms} ms`;
  if (ms < 60_000) return `${Math.round(ms / 1_000)} s`;
  if (ms < 3_600_000) return `${(ms / 60_000).toFixed(1)} min`;
  return `${(ms / 3_600_000).toFixed(1)} h`;
}

export function formatCompact(count: number): string {
  return count.toLocaleString('en-US', { notation: 'compact', maximumFractionDigits: 1 });
}

export function formatPercent(ratio: number): string {
  return ratio.toLocaleString('en-US', { style: 'percent', maximumFractionDigits: 0 });
}

const PURPOSES: Readonly<Record<string, string>> = {
  chat: 'Chat',
  eval: 'Evaluations',
  preview: 'Try-it chat',
};

export function purposeLabel(purpose: string | null): string {
  return purpose === null ? 'Unknown' : (PURPOSES[purpose] ?? purpose);
}
